import { FC, HTMLInputTypeAttribute, ReactNode, ChangeEvent } from 'react';
import { TextField, ThemeProvider } from '@mui/material';
import { azulDesign } from './AzulDesignTheme';

type AzulInputProps = {
  defaultValue?: unknown;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  helperTextAlign?: 'start' | 'end' | 'left' | 'right' | 'center' | 'justify' | 'match-parent';
  id?: string | undefined;
  label?: ReactNode;
  margin?: string;
  maxRows?: number;
  minRows?: number;
  multiline?: boolean;
  name?: string;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  type?: HTMLInputTypeAttribute;
  value?: string;
  width?: string;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
};

const AzulInput: FC<AzulInputProps> = ({
  defaultValue,
  disabled = false,
  error,
  helperText,
  helperTextAlign = 'start',
  id,
  label,
  margin,
  maxRows,
  minRows,
  multiline = false,
  name,
  placeholder,
  required = false,
  rows,
  type,
  value,
  width,
  onChange,
}: AzulInputProps) => (
  <ThemeProvider theme={azulDesign}>
    <TextField
      autoComplete='off'
      defaultValue={defaultValue}
      disabled={disabled}
      error={error}
      helperText={helperText}
      id={id}
      label={label}
      maxRows={maxRows}
      minRows={minRows}
      multiline={multiline}
      name={name}
      placeholder={placeholder}
      required={required}
      rows={rows}
      sx={{
        margin,
        width: { width },
        '.MuiFormHelperText-root': {
          textAlign: `${helperTextAlign}`,
        },
      }}
      type={type}
      value={value}
      variant='outlined'
      onChange={onChange}
    />
  </ThemeProvider>
);

export default AzulInput;
